import React, { useLayoutEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  AXIOS_GET,
  AXIOS_POST,
  AXIOS_UPDATE,
} from "../../../../server/api/crud";

const emptyRow = (partial, userdetails, voeding) => ({
  ...partial,
  eten: partial.eten ?? "",
  hoeveelheid: partial.hoeveelheid ?? "",
  tijd: normalizeTime(partial.tijd),
  opmerking: partial.opmerking ?? "",
  user_id: partial.user_id ?? userdetails?.user_id,
  voeding_id: partial.voeding_id ?? voeding?.id,
});

function normalizeTime(t) {
  if (t == null || t === "") return "";
  const s = String(t).trim();
  if (/^\d{2}:\d{2}/.test(s)) return s.slice(0, 5);
  return s;
}

const defaultDiary = (userdetails, voeding) => [
  emptyRow(
    {
      id: 1,
      maaltijd_type: "Ontbijt",
      tijd: "08:00",
    },
    userdetails,
    voeding
  ),
  emptyRow(
    {
      id: 2,
      maaltijd_type: "Tussendoor",
      tijd: "10:00",
    },
    userdetails,
    voeding
  ),
  emptyRow(
    {
      id: 3,
      maaltijd_type: "Middageten",
      tijd: "12:00",
    },
    userdetails,
    voeding
  ),
  emptyRow(
    {
      id: 4,
      maaltijd_type: "Tussendoor",
      tijd: "14:00",
    },
    userdetails,
    voeding
  ),
  emptyRow(
    {
      id: 5,
      maaltijd_type: "Avondeten",
      tijd: "16:00",
    },
    userdetails,
    voeding
  ),
  emptyRow(
    {
      id: 6,
      maaltijd_type: "Late avond snack",
      tijd: "18:00",
    },
    userdetails,
    voeding
  ),
];

const inputClass =
  "mt-1 block w-full rounded-xl border border-wa-border bg-wa-panel2/50 px-3 py-2.5 text-sm text-wa-text placeholder:text-wa-muted/70 ring-1 ring-inset ring-wa-border/50 focus:border-wa-accent focus:outline-none focus:ring-2 focus:ring-wa-accent/35 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-wa-panel/40";

const labelClass = "text-xs font-semibold uppercase tracking-wide text-wa-muted";

const EtenNotities = ({
  setSelected,
  setOpen,
  voeding,
  admin = null,
  userdetails,
}) => {
  const [foodDiary, setFoodDiary] = useState(() =>
    defaultDiary(userdetails, voeding)
  );
  const [isSaving, setIsSaving] = useState(false);

  const getData = async () => {
    try {
      const res = await AXIOS_GET(
        `voedsel/voedsellog/user/${userdetails?.user_id}`
      );
      if (res.status === 200 && res.data?.data?.length > 0) {
        setFoodDiary(
          res.data.data.map((row) => ({
            ...row,
            tijd: normalizeTime(row.tijd),
          }))
        );
      }
    } catch (e) {
      console.error("voedsellog fetch:", e);
    }
  };

  const disabled = admin != null;

  useLayoutEffect(() => {
    getData();
  }, []);

  const handleChange = (index, field, value) => {
    setFoodDiary((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  const handleNextPage = async () => {
    if (isSaving) return;
    const newObject = { voedsel: foodDiary };

    try {
      setIsSaving(true);
      if (userdetails?.role_id === 2) {
        const respons = await AXIOS_POST(`voedsel/voedsellog`, newObject);
        if (respons.status === 200) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Uw eetgewoonten zijn opgeslagen",
            showConfirmButton: false,
            timer: 2500,
          });
          const { id } = voeding;
          setSelected(1);
          try {
            await AXIOS_UPDATE(`voedsel/status`, id, { status: 1 });
          } catch (err) {
            console.error("voedsel status:", err);
          }
        } else {
          throw new Error(`Status ${respons.status}`);
        }
      } else {
        setSelected(1);
      }
    } catch (error) {
      console.error("opslaan voedsellog:", error);
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Opslaan is mislukt. Probeer opnieuw.",
        showConfirmButton: true,
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="rounded-2xl border border-wa-border/80 bg-wa-panel/20 p-4 shadow-sm ring-1 ring-black/[0.02] dark:bg-wa-panel2/15 dark:ring-white/[0.04] sm:p-6 lg:p-8">
      <div className="rounded-xl border border-amber-500/25 bg-amber-500/10 px-4 py-3 text-center text-sm font-medium text-amber-950 dark:text-amber-100 sm:text-left">
        Stap 1 — 1 daags eetdagboek: noteer wat, hoeveel, wanneer en eventuele
        opmerkingen per moment.
      </div>

      <div className="mt-6 hidden gap-3 border-b border-wa-border pb-2 text-xs font-semibold uppercase tracking-wide text-wa-muted lg:grid lg:grid-cols-12 lg:px-1">
        <div className="col-span-2">Maaltijd</div>
        <div className="col-span-3">Wat eet je?</div>
        <div className="col-span-1 text-center">Aantal</div>
        <div className="col-span-2">Tijd</div>
        <div className="col-span-4">Opmerking</div>
      </div>

      <div className="mt-4 space-y-4 lg:mt-2 lg:space-y-0">
        {foodDiary.map((entry, index) => (
          <article
            key={entry.id ?? index}
            className="rounded-2xl border border-wa-border bg-wa-panel2/30 p-4 dark:bg-wa-panel/25 lg:rounded-none lg:border-0 lg:border-b lg:border-wa-border/70 lg:bg-transparent lg:p-3 lg:px-1"
          >
            <div className="grid grid-cols-1 gap-4 lg:grid lg:grid-cols-12 lg:items-start lg:gap-3">
              <div className="lg:col-span-2">
                <h3 className="text-base font-bold text-wa-text lg:pt-2.5 lg:text-sm lg:font-semibold">
                  {entry.maaltijd_type}
                </h3>
              </div>

              <div className="lg:col-span-3">
                <label htmlFor={`eten-${index}`} className={labelClass}>
                  Wat eet je?
                </label>
                <input
                  id={`eten-${index}`}
                  type="text"
                  placeholder="Bijv. boterham met kaas"
                  disabled={disabled}
                  value={entry.eten}
                  onChange={(e) =>
                    handleChange(index, "eten", e.target.value)
                  }
                  className={inputClass}
                />
              </div>

              <div className="grid grid-cols-2 gap-4 lg:col-span-3 lg:grid-cols-2">
                <div>
                  <label
                    htmlFor={`hoeveelheid-${index}`}
                    className={labelClass}
                  >
                    Hoeveelheid
                  </label>
                  <input
                    id={`hoeveelheid-${index}`}
                    type="number"
                    min={0}
                    step={1}
                    inputMode="numeric"
                    placeholder="0"
                    disabled={disabled}
                    value={entry.hoeveelheid}
                    onChange={(e) =>
                      handleChange(index, "hoeveelheid", e.target.value)
                    }
                    className={inputClass}
                  />
                </div>
                <div>
                  <label htmlFor={`tijd-${index}`} className={labelClass}>
                    Tijd
                  </label>
                  <input
                    id={`tijd-${index}`}
                    type="time"
                    disabled={disabled}
                    value={entry.tijd || ""}
                    onChange={(e) =>
                      handleChange(index, "tijd", e.target.value)
                    }
                    className={inputClass}
                  />
                </div>
              </div>

              <div className="lg:col-span-4">
                <label htmlFor={`opm-${index}`} className={labelClass}>
                  Opmerking
                </label>
                <input
                  id={`opm-${index}`}
                  type="text"
                  placeholder="Optioneel"
                  disabled={disabled}
                  value={entry.opmerking}
                  onChange={(e) =>
                    handleChange(index, "opmerking", e.target.value)
                  }
                  className={inputClass}
                />
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-8 flex flex-col-reverse gap-3 sm:flex-row sm:items-center sm:justify-between">
        <button
          type="button"
          onClick={() => setOpen(false)}
          disabled={isSaving}
          className="inline-flex w-full items-center justify-center rounded-xl border border-wa-border bg-wa-panel2/60 px-4 py-3 text-sm font-semibold text-wa-text shadow-sm transition hover:bg-wa-hover disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto"
        >
          Annuleren
        </button>
        <button
          type="button"
          onClick={handleNextPage}
          disabled={isSaving}
          className="inline-flex w-full items-center justify-center rounded-xl bg-wa-accent px-5 py-3 text-sm font-semibold text-wa-onaccent shadow-md transition hover:bg-wa-accentdeep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto sm:min-w-[10rem]"
        >
          {isSaving ? "Bezig…" : "Volgende"}
        </button>
      </div>
    </div>
  );
};

export default EtenNotities;
